export const uiListCarousel = {
    name: 'UI List Carousel',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        captions: {
            name: 'Captions',
            type: 'Array',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ size: { min: 3, max: 3 } }],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['caption'] }],
                linkType: 'Entry'
            }
        },
        autoplay: {
            name: 'Autoplay',
            type: 'Boolean',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiListCarousel.js.map